import { FC } from "react";
import { MsdDto } from "src/app/services/generatedApi";
import { MsdBodyZone } from "./MsdBodyZone";
import { Box, Divider } from "@mui/material";
import {
  msdLowBackRiskFactors,
  msdHandWristRiskFactors,
  msdNeckShoulderRiskFactors,
  msdKneeRiskFactors,
} from "src/components/organisms/assessment/msd/msdImageMapping";

interface MsdBodyZonesProps {
  msdData?: MsdDto;
  handleUpdate: (
    bodyZone: keyof MsdDto,
    category: string,
    propertyName: string,
    value: boolean,
  ) => void;
}

export const MsdBodyZones: FC<MsdBodyZonesProps> = ({
  msdData,
  handleUpdate,
}) => {
  return (
    <Box>
      <MsdBodyZone
        title="Low Back Assessment"
        bodyZone="lowBack"
        riskFactors={msdLowBackRiskFactors}
        msdData={msdData}
        handleUpdate={handleUpdate}
      />
      <Divider sx={{ my: 4 }} />

      <MsdBodyZone
        title="Hand & Wrist Assessment"
        bodyZone="handWrist"
        riskFactors={msdHandWristRiskFactors}
        msdData={msdData}
        handleUpdate={handleUpdate}
      />
      <Divider sx={{ my: 4 }} />

      <MsdBodyZone
        title="Neck & Shoulder Assessment"
        bodyZone="neckShoulder"
        riskFactors={msdNeckShoulderRiskFactors}
        msdData={msdData}
        handleUpdate={handleUpdate}
      />
      <Divider sx={{ my: 4 }} />

      <MsdBodyZone
        title="Knee Assessment"
        bodyZone="knee"
        riskFactors={msdKneeRiskFactors}
        msdData={msdData}
        handleUpdate={handleUpdate}
      />
    </Box>
  );
};
